import React from 'react';

import { Alert, Group, Stack, Text } from '@mantine/core';
import { IconShieldHalf } from '@tabler/icons-react';
import { WHITEBOARD_SIZES } from 'components/Workout/whiteboardDisplay';
import PreviewAthleteNotes from 'pages/private/owner/Workouts/Library/components/WorkoutLibrary/WorkoutTemplates/components/ModalWorkoutTemplatePreview/PreviewAthleteNotes';
import PreviewSection from 'pages/private/owner/Workouts/Library/components/WorkoutLibrary/WorkoutTemplates/components/ModalWorkoutTemplatePreview/PreviewSection';
import type {
  PreviewMovementExtraRenderer,
  WorkoutTemplatePreviewData,
} from 'pages/private/owner/Workouts/Library/components/WorkoutLibrary/WorkoutTemplates/components/ModalWorkoutTemplatePreview/types';

/** Renders preview-shaped template data. For raw WorkoutRetrieve, use WorkoutDetailView. */
interface WorkoutDetailProps {
  template: WorkoutTemplatePreviewData;
  showCoachNotes?: boolean;
  indexOffset?: number;
  enlarged?: boolean;
  renderMovementExtra?: PreviewMovementExtraRenderer;
}

const WorkoutDetail = ({
  template,
  showCoachNotes = true,
  indexOffset = 0,
  enlarged = false,
  renderMovementExtra,
}: WorkoutDetailProps): JSX.Element => (
  <Stack spacing='lg'>
    {template.athleteNotes && <PreviewAthleteNotes notes={template.athleteNotes} enlarged={enlarged} />}
    {showCoachNotes && template.coachNotes && (
      <Alert
        icon={enlarged ? undefined : <IconShieldHalf size={16} />}
        title={
          enlarged ? (
            <Group spacing={8} align='center' noWrap>
              <IconShieldHalf size={WHITEBOARD_SIZES.notesIcon} />
              <span style={{ fontSize: WHITEBOARD_SIZES.notesTitle }}>Coach Notes</span>
            </Group>
          ) : (
            'Coach Notes'
          )
        }
        color='orange'
        variant='light'
      >
        <Text size={enlarged ? WHITEBOARD_SIZES.bodyText : 'sm'} sx={{ whiteSpace: 'pre-wrap' }}>
          {template.coachNotes}
        </Text>
      </Alert>
    )}
    {template.sections.map((section, index) => (
      <PreviewSection
        key={index}
        section={section}
        index={indexOffset + index}
        enlarged={enlarged}
        renderMovementExtra={renderMovementExtra}
      />
    ))}
  </Stack>
);

export default WorkoutDetail;
